
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"35","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M20.9 28.438h-11c-.292 0-.571.115-.778.32a1.09 1.09 0 00-.322.773v4.375c0 .29.116.569.322.774.207.205.486.32.778.32h11c.292 0 .572-.115.778-.32a1.09 1.09 0 00.322-.774v-4.375c0-.29-.116-.568-.322-.773a1.103 1.103 0 00-.778-.32zm0-8.75h-11c-.292 0-.571.115-.778.32a1.09 1.09 0 00-.322.773v4.375c0 .29.116.569.322.774.207.205.486.32.778.32h11c.292 0 .572-.115.778-.32a1.09 1.09 0 00.322-.774v-4.375c0-.29-.116-.568-.322-.773a1.103 1.103 0 00-.778-.32zm13.2 8.75h-8.8c-.292 0-.571.115-.778.32a1.09 1.09 0 00-.322.773v4.375c0 .29.116.569.322.774.207.205.486.32.778.32h8.8c.292 0 .572-.115.778-.32a1.09 1.09 0 00.322-.774v-4.375c0-.29-.116-.568-.322-.773a1.103 1.103 0 00-.778-.32z","fill":"#0067AD"}}),_c('path',{attrs:{"d":"M44 11.026v23.428a.545.545 0 01-.55.547h-3.3a.551.551 0 01-.55-.547V14.22c0-.29-.116-.568-.322-.774a1.103 1.103 0 00-.778-.32h-33c-.292 0-.572.115-.778.32a1.09 1.09 0 00-.322.774v20.234a.545.545 0 01-.55.547H.55a.551.551 0 01-.55-.547V11.026c.001-.647.194-1.279.555-1.817.36-.539.873-.96 1.473-1.21l18.7-7.745a3.32 3.32 0 012.537 0L41.972 8c.6.25 1.112.671 1.473 1.21.36.538.554 1.17.555 1.817z","fill":"#8A94A6"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h44v35H0z"}})])])])
          )
        }
      }
    